var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 8.33301L8.33398 9.07375L8.33398 14.9997",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 8.33301L11.666 9.07375L11.666 14.9997",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 5.83301L14.9994 16.7705C14.9994 17.1849 14.8238 17.5823 14.5112 17.8754C14.1986 18.1684 13.7747 18.333 13.3327 18.333H6.66602C6.22399 18.333 5.80007 18.1684 5.4875 17.8754C5.17494 17.5823 4.99935 17.1849 4.99935 16.7705L4.16602 5.83301H15.8327Z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.66699V3.16699C7.5 3.71928 7.94772 4.16699 8.5 4.16699H11.5C12.0523 4.16699 12.5 3.71928 12.5 3.16699V2.66699C12.5 2.11471 12.0523 1.66699 11.5 1.66699H8.5C7.94772 1.66699 7.5 2.11471 7.5 2.66699Z",
    stroke: "#939393",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 4.66699V5.33366C3.33398 5.6098 3.55784 5.83366 3.83398 5.83366H16.1673C16.4435 5.83366 16.6673 5.6098 16.6673 5.33366V4.66699C16.6673 4.39085 16.4435 4.16699 16.1673 4.16699H3.83398C3.55784 4.16699 3.33398 4.39085 3.33398 4.66699Z",
    stroke: "#939393",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAlt);
export default __webpack_public_path__ + "static/media/trash-alt.709380d5f4a023e9b9ed72b3112915a2.svg";
export { ForwardRef as ReactComponent };